import { render, staticRenderFns } from "./WebCall.vue?vue&type=template&id=5a6489f6&scoped=true"
import script from "./WebCall.vue?vue&type=script&lang=js"
export * from "./WebCall.vue?vue&type=script&lang=js"
import style0 from "./WebCall.vue?vue&type=style&index=0&id=5a6489f6&prod&lang=scss&scoped=true&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5a6489f6",
  null
  
)

export default component.exports